export default __webpack_public_path__ + "static/media/Kriti and Kai_Johnsons Locust Hall Farm_AS Nagpal_5.6dad831b.JPG";